// extracted by mini-css-extract-plugin
export default {"uploadImage":"UploadImageField_upload-image__fuyI1"};